/**
 * @file
 */
(function ($) {
  "use strict";
  Drupal.behaviors.cpsTheme = {
    attach: function (context, settings) {
      var url = window.location.href;
      var base_url = window.location.origin;
      if (
        url ===
        base_url +
        "/legal/p_to_r/rape_and_sexual_offences/soa_2003_and_soa_1956/#a14"
      ) {
        window.location.replace(
          base_url +
          "/legal-guidance/rape-and-sexual-offences-chapter-2-sexual-offences-act-2003-principal-offences-and#a14"
        );
      }

      //smooth anchors scrolling
      $(document).on("click", 'a[href^="#"]', function (event) {
        event.preventDefault();
      });
      $(once('cpsClickHref', context === document ? 'body' : context))
        .on("click", 'a[href^="#"]', function (e) {
          e.preventDefault();

          var paddingTop = 0;
          if ($.attr(this, "href").indexOf("consultation-") !== -1) {
            paddingTop = 100;
          }

          if ($(this).attr("id") == "closeFootnote") {
            $("#reportFootnotes").removeClass("open");
          }

          if ($.attr(this, "href").indexOf("reference-") === 1) {
            $("#reportFootnotes").addClass("open");
            $("#reportFootnotes ol li").removeClass("active");
            var refNum = $.attr(this, "href").split("reference-");
            $("#reportFootnotes")
              .find("ol li:nth-child(" + refNum[1] + ")")
              .addClass("active");
          } else if ($.attr(this, "href") !== "#") {
            $("html, body").animate(
              {
                scrollTop: $($.attr(this, "href")).offset().top - paddingTop,
              },
              500
            );
          }
        });

      $(document).keyup(function (e) {
        if (e.key === "Escape") { // close footnotes on esc.
          $("#reportFootnotes").removeClass("open");
        }
      });


      //scrollToMainContent
      const mainContentLink = document.getElementById("scroll-to-main");

      if (mainContentLink) {
        mainContentLink.addEventListener("click", function (e) {
          e.preventDefault();
          const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
          const href = this.getAttribute("href");
          const target = document.querySelector(href);
          const offsetTop = target.offsetTop;

          if (isIE11) {
            window.scrollTo(0, offsetTop);
          } else {
            window.scrollTo({
              top: offsetTop,
              behavior: "smooth",
            });
          }

          target.focus(); // Setting focus
          if (target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            target.focus(); // Setting focus
          };

        });
      }

      $("#search--toggle").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("open")) {
          $("#search--form").removeClass("open");
        } else {
          $("#search--form").addClass("open");
        }
        $(this).toggleClass("open");
        $(".colour-contrast").toggleClass("hidden");
        $(".text-sizing").toggleClass("hidden");
      });



      //fix for views exposed form reset button
      $("input[id^='edit-reset']").on("click", function (event) {
        event.preventDefault();
        location.reload();
      });

      //$('.bef-datepicker').attr('aria-describedby', 'datepickerLabel');

      if ($("input[id^='edit-publication-date-after']").val() !== "") {
        $("input[id^='edit-publication-date-after']").addClass("not-empty");
      }

      $("input[id^='edit-publication-date-after']").on("change", function () {
        if ($(this).val() !== "") {
          $(this).addClass("not-empty");
        } else {
          $(this).removeClass("not-empty");
        }
      });

      if ($("input[id^='edit-publication-date-before']").val() !== "") {
        $("input[id^='edit-publication-date-before']").addClass("not-empty");
      }

      $("input[id^='edit-publication-date-before']").on("change", function () {
        if ($(this).val() !== "") {
          $(this).addClass("not-empty");
        } else {
          $(this).removeClass("not-empty");
        }
      });


      $("input[id^='edit-publication-date-after']").datepicker({
        showOn: 'button',
        buttonImageOnly: false,
        buttonText: 'Calendar View',
        dayNamesShort: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        showButtonPanel: true,
        closeText: 'Close',
        onClose: removeAria
      });
      $("input[id^='edit-publication-date-before']").datepicker({
        showOn: 'button',
        buttonImageOnly: false,
        dayNamesShort: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        showButtonPanel: true,
        closeText: 'Close',
        onClose: removeAria
      });

      dayTripper();

      /* Datepicker Accessibility fix */
      function dayTripper() {
        $('.ui-datepicker-trigger').click(function () {

          var trigger = $(this);

          setTimeout(function () {
            var today = $('.ui-datepicker-today a')[0];

            if (!today) {
              today = $('.ui-state-active')[0] ||
                $('.ui-state-default')[0];
            }


            // Hide the entire page (except the date picker)
            // from screen readers to prevent document navigation
            // (by headings, etc.) while the popup is open
            $("main").attr('id', 'dp-container');
            $("#dp-container").attr('aria-hidden', 'true');

            // Hide the "today" button because it doesn't do what
            // you think it supposed to do
            $(".ui-datepicker-current").hide();

            var inputId = 'edit-publication-date-after';

            if (trigger.parent('div').hasClass('form-item-publication-date-before')) {
              var inputId = 'edit-publication-date-before';
            }

            $(today).focus();
            datePickHandler(inputId);
            $(document).on('click', '#ui-datepicker-div .ui-datepicker-close', function () {
              closeCalendar(inputId);
            });
          }, 0);
        });
      }

      function datePickHandler(inputId) {
        var activeDate;
        var container = document.getElementById('ui-datepicker-div');
        //var input = document.getElementById(inputId);

        var input = document.querySelectorAll('[id^=' + inputId + ']')[0];


        if (!container || !input) {
          return;
        }

        // $(container).find('table').first().attr('role', 'grid');

        container.setAttribute('role', 'application');
        container.setAttribute('aria-label', 'Calendar view date-picker');

        // the top controls:
        var prev = $('.ui-datepicker-prev', container)[0],
          next = $('.ui-datepicker-next', container)[0];


        // This is the line that needs to be fixed for use on pages with base URL set in head
        next.href = 'javascript:void(0)';
        prev.href = 'javascript:void(0)';

        next.setAttribute('role', 'button');
        next.removeAttribute('title');
        prev.setAttribute('role', 'button');
        prev.removeAttribute('title');

        appendOffscreenMonthText(next);
        appendOffscreenMonthText(prev);

        // delegation won't work here for whatever reason, so we are
        // forced to attach individual click listeners to the prev /
        // next month buttons each time they are added to the DOM
        $(next).on('click', handleNextClicks);
        $(prev).on('click', handlePrevClicks);

        monthDayYearText(inputId);

        $(container).on('keydown', function calendarKeyboardListener(keyVent) {
          var which = keyVent.which;
          var target = keyVent.target;
          var dateCurrent = getCurrentDate(container);

          if (!dateCurrent) {
            dateCurrent = $('a.ui-state-default')[0];
            setHighlightState(dateCurrent, container);
          }

          if (27 === which) {
            keyVent.stopPropagation();
            return closeCalendar(inputId);
          } else if (which === 9 && keyVent.shiftKey) { // SHIFT + TAB
            keyVent.preventDefault();
            if ($(target).hasClass('ui-datepicker-close')) { // close button
              $('.ui-datepicker-prev')[0].focus();
            } else if ($(target).hasClass('ui-state-default')) { // a date link
              $('.ui-datepicker-close')[0].focus();
            } else if ($(target).hasClass('ui-datepicker-prev')) { // the prev link
              $('.ui-datepicker-next')[0].focus();
            } else if ($(target).hasClass('ui-datepicker-next')) { // the next link
              activeDate = $('.ui-state-highlight') ||
                $('.ui-state-active')[0];
              if (activeDate) {
                activeDate.focus();
              }
            }
          } else if (which === 9) { // TAB
            keyVent.preventDefault();
            if ($(target).hasClass('ui-datepicker-close')) { // close button
              activeDate = $('.ui-state-highlight') ||
                $('.ui-state-active')[0];
              if (activeDate) {
                activeDate.focus();
              }
            } else if ($(target).hasClass('ui-state-default')) {
              $('.ui-datepicker-next')[0].focus();
            } else if ($(target).hasClass('ui-datepicker-next')) {
              $('.ui-datepicker-prev')[0].focus();
            } else if ($(target).hasClass('ui-datepicker-prev')) {
              $('.ui-datepicker-close')[0].focus();
            }
          } else if (which === 37) { // LEFT arrow key
            // if we're on a date link...
            if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
              keyVent.preventDefault();
              previousDay(target);
            }
          } else if (which === 39) { // RIGHT arrow key
            // if we're on a date link...
            if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
              keyVent.preventDefault();
              nextDay(target);
            }
          } else if (which === 38) { // UP arrow key
            if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
              keyVent.preventDefault();
              upHandler(target, container, prev);
            }
          } else if (which === 40) { // DOWN arrow key
            if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
              keyVent.preventDefault();
              downHandler(target, container, next);
            }
          } else if (which === 13) { // ENTER
            if ($(target).hasClass('ui-state-default')) {
              setTimeout(function () {
                closeCalendar(inputId);
              }, 100);
            } else if ($(target).hasClass('ui-datepicker-prev')) {
              handlePrevClicks();
            } else if ($(target).hasClass('ui-datepicker-next')) {
              handleNextClicks();
            }
          } else if (32 === which) {
            if ($(target).hasClass('ui-datepicker-prev') || $(target).hasClass('ui-datepicker-next')) {
              target.click();
            }
          } else if (33 === which) { // PAGE UP
            moveOneMonth(target, 'prev');
          } else if (34 === which) { // PAGE DOWN
            moveOneMonth(target, 'next');
          } else if (36 === which) { // HOME
            var firstOfMonth = $(target).closest('tbody').find('.ui-state-default')[0];
            if (firstOfMonth) {
              firstOfMonth.focus();
              setHighlightState(firstOfMonth, $('#ui-datepicker-div')[0]);
            }
          } else if (35 === which) { // END
            var $daysOfMonth = $(target).closest('tbody').find('.ui-state-default');
            var lastDay = $daysOfMonth[$daysOfMonth.length - 1];
            if (lastDay) {
              lastDay.focus();
              setHighlightState(lastDay, $('#ui-datepicker-div')[0]);
            }
          }
          $(".ui-datepicker-current").hide();
        });
      }

      function closeCalendar(inputId) {
        var container = $('#ui-datepicker-div');
        $(container).off('keydown');
        //var input = $('#datepicker')[0];
        var input = $("input[id^='" + inputId + "']");
        $(input).datepicker('hide');

        input.focus();
      }

      function removeAria() {
        // make the rest of the page accessible again:
        $("#dp-container").removeAttr('aria-hidden');
        $("#skipnav").removeAttr('aria-hidden');
      }

      ///////////////////////////////
      //////////////////////////// //
      ///////////////////////// // //
      // UTILITY-LIKE THINGS // // //
      ///////////////////////// // //
      //////////////////////////// //
      ///////////////////////////////
      function isOdd(num) {
        return num % 2;
      }

      function moveOneMonth(currentDate, dir) {
        var button = (dir === 'next')
          ? $('.ui-datepicker-next')[0]
          : $('.ui-datepicker-prev')[0];

        if (!button) {
          return;
        }

        var ENABLED_SELECTOR = '#ui-datepicker-div tbody td:not(.ui-state-disabled)';
        var $currentCells = $(ENABLED_SELECTOR);
        var currentIdx = $.inArray(currentDate.parentNode, $currentCells);

        button.click();
        setTimeout(function () {
          updateHeaderElements();

          var $newCells = $(ENABLED_SELECTOR);
          var newTd = $newCells[currentIdx];
          var newAnchor = newTd && $(newTd).find('a')[0];

          while (!newAnchor) {
            currentIdx--;
            newTd = $newCells[currentIdx];
            newAnchor = newTd && $(newTd).find('a')[0];
          }

          setHighlightState(newAnchor, $('#ui-datepicker-div')[0]);
          newAnchor.focus();

        }, 0);

      }

      function handleNextClicks() {
        setTimeout(function () {
          updateHeaderElements();
          prepHighlightState();
          $('.ui-datepicker-next').focus();
          $(".ui-datepicker-current").hide();
        }, 0);
      }

      function handlePrevClicks() {
        setTimeout(function () {
          updateHeaderElements();
          prepHighlightState();
          $('.ui-datepicker-prev').focus();
          $(".ui-datepicker-current").hide();
        }, 0);
      }

      function previousDay(dateLink) {
        var container = document.getElementById('ui-datepicker-div');
        if (!dateLink) {
          return;
        }
        var td = $(dateLink).closest('td');
        if (!td) {
          return;
        }

        var prevTd = $(td).prev(),
          prevDateLink = $('a.ui-state-default', prevTd)[0];

        if (prevTd && prevDateLink) {
          setHighlightState(prevDateLink, container);
          prevDateLink.focus();
        } else {
          handlePrevious(dateLink);
        }
      }


      function handlePrevious(target) {
        var container = document.getElementById('ui-datepicker-div');
        if (!target) {
          return;
        }
        var currentRow = $(target).closest('tr');
        if (!currentRow) {
          return;
        }
        var previousRow = $(currentRow).prev();

        if (!previousRow || previousRow.length === 0) {
          // there is not previous row, so we go to previous month...
          previousMonth();
        } else {
          var prevRowDates = $('td a.ui-state-default', previousRow);
          var prevRowDate = prevRowDates[prevRowDates.length - 1];

          if (prevRowDate) {
            setTimeout(function () {
              setHighlightState(prevRowDate, container);
              prevRowDate.focus();
            }, 0);
          }
        }
      }

      function previousMonth() {
        var prevLink = $('.ui-datepicker-prev')[0];
        var container = document.getElementById('ui-datepicker-div');
        prevLink.click();
        // focus last day of new month
        setTimeout(function () {
          var trs = $('tr', container),
            lastRowTdLinks = $('td a.ui-state-default', trs[trs.length - 1]),
            lastDate = lastRowTdLinks[lastRowTdLinks.length - 1];

          // updating the cached header elements
          updateHeaderElements();

          setHighlightState(lastDate, container);
          lastDate.focus();

        }, 0);
      }

      ///////////////// NEXT /////////////////
      /**
       * Handles right arrow key navigation
       * @param  {HTMLElement} dateLink The target of the keyboard event
       */
      function nextDay(dateLink) {
        var container = document.getElementById('ui-datepicker-div');
        if (!dateLink) {
          return;
        }
        var td = $(dateLink).closest('td');
        if (!td) {
          return;
        }
        var nextTd = $(td).next(),
          nextDateLink = $('a.ui-state-default', nextTd)[0];

        if (nextTd && nextDateLink) {
          setHighlightState(nextDateLink, container);
          nextDateLink.focus(); // the next day (same row)
        } else {
          handleNext(dateLink);
        }
      }

      function handleNext(target) {
        var container = document.getElementById('ui-datepicker-div');
        if (!target) {
          return;
        }
        var currentRow = $(target).closest('tr'),
          nextRow = $(currentRow).next();

        if (!nextRow || nextRow.length === 0) {
          nextMonth();
        } else {
          var nextRowFirstDate = $('a.ui-state-default', nextRow)[0];
          if (nextRowFirstDate) {
            setHighlightState(nextRowFirstDate, container);
            nextRowFirstDate.focus();
          }
        }
      }

      function nextMonth() {
        nextMon = $('.ui-datepicker-next')[0];
        var container = document.getElementById('ui-datepicker-div');
        nextMon.click();
        // focus the first day of the new month
        setTimeout(function () {
          // updating the cached header elements
          updateHeaderElements();

          var firstDate = $('a.ui-state-default', container)[0];
          setHighlightState(firstDate, container);
          firstDate.focus();
        }, 0);
      }

      /////////// UP ///////////
      /**
       * Handle the up arrow navigation through dates
       * @param  {HTMLElement} target   The target of the keyboard event (day)
       * @param  {HTMLElement} cont     The calendar container
       * @param  {HTMLElement} prevLink Link to navigate to previous month
       */
      function upHandler(target, cont, prevLink) {
        prevLink = $('.ui-datepicker-prev')[0];
        var rowContext = $(target).closest('tr');
        if (!rowContext) {
          return;
        }
        var rowTds = $('td', rowContext),
          rowLinks = $('a.ui-state-default', rowContext),
          targetIndex = $.inArray(target, rowLinks),
          prevRow = $(rowContext).prev(),
          prevRowTds = $('td', prevRow),
          parallel = prevRowTds[targetIndex],
          linkCheck = $('a.ui-state-default', parallel)[0];

        if (prevRow && parallel && linkCheck) {
          // there is a previous row, a td at the same index
          // of the target AND theres a link in that td
          setHighlightState(linkCheck, cont);
          linkCheck.focus();
        } else {
          // we're either on the first row of a month, or we're on the
          // second and there is not a date link directly above the target
          prevLink.click();
          setTimeout(function () {
            // updating the cached header elements
            updateHeaderElements();
            var newRows = $('tr', cont),
              lastRow = newRows[newRows.length - 1],
              lastRowTds = $('td', lastRow),
              tdParallelIndex = $.inArray(target.parentNode, rowTds),
              newParallel = lastRowTds[tdParallelIndex],
              newCheck = $('a.ui-state-default', newParallel)[0];

            if (lastRow && newParallel && newCheck) {
              setHighlightState(newCheck, cont);
              newCheck.focus();
            } else {
              // theres no date link on the last week (row) of the new month
              // meaning its an empty cell, so we'll try the 2nd to last week
              var secondLastRow = newRows[newRows.length - 2],
                secondTds = $('td', secondLastRow),
                targetTd = secondTds[tdParallelIndex],
                linkCheck = $('a.ui-state-default', targetTd)[0];

              if (linkCheck) {
                setHighlightState(linkCheck, cont);
                linkCheck.focus();
              }

            }
          }, 0);
        }
      }

      //////////////// DOWN ////////////////
      /**
       * Handles down arrow navigation through dates in calendar
       * @param  {HTMLElement} target   The target of the keyboard event (day)
       * @param  {HTMLElement} cont     The calendar container
       * @param  {HTMLElement} nextLink Link to navigate to next month
       */
      function downHandler(target, cont, nextLink) {
        nextLink = $('.ui-datepicker-next')[0];
        var targetRow = $(target).closest('tr');
        if (!targetRow) {
          return;
        }
        var targetCells = $('td', targetRow),
          cellIndex = $.inArray(target.parentNode, targetCells), // the td (parent of target) index
          nextRow = $(targetRow).next(),
          nextRowCells = $('td', nextRow),
          nextWeekTd = nextRowCells[cellIndex],
          nextWeekCheck = $('a.ui-state-default', nextWeekTd)[0];

        if (nextRow && nextWeekTd && nextWeekCheck) {
          // theres a next row, a TD at the same index of `target`,
          // and theres an anchor within that td
          setHighlightState(nextWeekCheck, cont);
          nextWeekCheck.focus();
        } else {
          nextLink.click();

          setTimeout(function () {
            // updating the cached header elements
            updateHeaderElements();

            var nextMonthTrs = $('tbody tr', cont),
              firstTds = $('td', nextMonthTrs[0]),
              firstParallel = firstTds[cellIndex],
              firstCheck = $('a.ui-state-default', firstParallel)[0];

            if (firstParallel && firstCheck) {
              setHighlightState(firstCheck, cont);
              firstCheck.focus();
            } else {
              // lets try the second row b/c we didnt find a
              // date link in the first row at the target's index
              var secondRow = nextMonthTrs[1],
                secondTds = $('td', secondRow),
                secondRowTd = secondTds[cellIndex],
                secondCheck = $('a.ui-state-default', secondRowTd)[0];

              if (secondRow && secondCheck) {
                setHighlightState(secondCheck, cont);
                secondCheck.focus();
              }
            }
          }, 0);
        }
      }


      function onCalendarHide(inputId) {
        closeCalendar(inputId);
      }

      // add an aria-label to the date link indicating the currently focused date
      // (formatted identically to the required format: mm/dd/yyyy)
      function monthDayYearText(inputId) {
        var cleanUps = $('.amaze-date');

        $(cleanUps).each(function (clean) {
          // each(cleanUps, function (clean) {
          clean.parentNode.removeChild(clean);
        });

        var datePickDiv = document.getElementById('ui-datepicker-div');
        // in case we find no datepick div
        if (!datePickDiv) {
          return;
        }

        var dates = $('a.ui-state-default', datePickDiv);
        $(dates).attr('role', 'button').on('keydown', function (e) {
          if (e.which === 32) {
            e.preventDefault();
            e.target.click();
            setTimeout(function () {
              closeCalendar(inputId);
            }, 100);
          }
        });
        $(dates).each(function (index, date) {
          var currentRow = $(date).closest('tr'),
            currentTds = $('td', currentRow),
            currentIndex = $.inArray(date.parentNode, currentTds),
            headThs = $('thead tr th', datePickDiv),
            dayIndex = headThs[currentIndex],
            daySpan = $('span', dayIndex)[0],
            monthName = $('.ui-datepicker-month', datePickDiv)[0].innerHTML,
            year = $('.ui-datepicker-year', datePickDiv)[0].innerHTML,
            number = date.innerHTML;

          if (!daySpan || !monthName || !number || !year) {
            return;
          }

          // AT Reads: {month} {date} {year} {day}
          // "December 18 2014 Thursday"
          var dateText = date.innerHTML + ' ' + monthName + ' ' + year + ' ' + daySpan.title;
          // AT Reads: {date(number)} {name of day} {name of month} {year(number)}
          // var dateText = date.innerHTML + ' ' + daySpan.title + ' ' + monthName + ' ' + year;
          // add an aria-label to the date link reading out the currently focused date
          date.setAttribute('aria-label', dateText);
        });
      }



      // update the cached header elements because we're in a new month or year
      function updateHeaderElements() {
        var context = document.getElementById('ui-datepicker-div');
        if (!context) {
          return;
        }

        //  $(context).find('table').first().attr('role', 'grid');

        var prev = $('.ui-datepicker-prev', context)[0];
        var next = $('.ui-datepicker-next', context)[0];

        //make them click/focus - able
        next.href = 'javascript:void(0)';
        prev.href = 'javascript:void(0)';

        next.setAttribute('role', 'button');
        prev.setAttribute('role', 'button');
        appendOffscreenMonthText(next);
        appendOffscreenMonthText(prev);

        $(next).on('click', handleNextClicks);
        $(prev).on('click', handlePrevClicks);

        // add month day year text
        monthDayYearText();
      }


      function prepHighlightState() {
        var highlight;
        var cage = document.getElementById('ui-datepicker-div');
        highlight = $('.ui-state-highlight', cage)[0] ||
          $('.ui-state-default', cage)[0];
        if (highlight && cage) {
          setHighlightState(highlight, cage);
        }
      }

      // Set the highlighted class to date elements, when focus is received
      function setHighlightState(newHighlight, container) {
        var prevHighlight = getCurrentDate(container);
        // remove the highlight state from previously
        // highlighted date and add it to our newly active date
        $(prevHighlight).removeClass('ui-state-highlight');
        $(newHighlight).addClass('ui-state-highlight');
      }


      // grabs the current date based on the highlight class
      function getCurrentDate(container) {
        var currentDate = $('.ui-state-highlight', container)[0];
        return currentDate;
      }

      /**
       * Appends logical next/prev month text to the buttons
       * - ex: Next Month, January 2015
       *       Previous Month, November 2014
       */
      function appendOffscreenMonthText(button) {
        var buttonText;
        var isNext = $(button).hasClass('ui-datepicker-next');
        var months = [
          'january', 'february',
          'march', 'april',
          'may', 'june', 'july',
          'august', 'september',
          'october',
          'november', 'december'
        ];

        var currentMonth = $('.ui-datepicker-title .ui-datepicker-month').text().toLowerCase();
        var monthIndex = $.inArray(currentMonth.toLowerCase(), months);
        var currentYear = $('.ui-datepicker-title .ui-datepicker-year').text().toLowerCase();
        var adjacentIndex = (isNext) ? monthIndex + 1 : monthIndex - 1;

        if (isNext && currentMonth === 'december') {
          currentYear = parseInt(currentYear, 10) + 1;
          adjacentIndex = 0;
        } else if (!isNext && currentMonth === 'january') {
          currentYear = parseInt(currentYear, 10) - 1;
          adjacentIndex = months.length - 1;
        }

        buttonText = (isNext)
          ? 'Next Month, ' + firstToCap(months[adjacentIndex]) + ' ' + currentYear
          : 'Previous Month, ' + firstToCap(months[adjacentIndex]) + ' ' + currentYear;

        $(button).find('.ui-icon').html(buttonText);

      }

      // Returns the string with the first letter capitalized
      function firstToCap(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
      }

      /* Datepicker Accessibility fix */
    },
  };

  Drupal.behaviors.cpsMultipleSlider = {
    attach: function (context, settings) {
      if ($(".slideshow")) {
        $(".slideshow").each(function (index) {
          var owlSlideshow = $(this);
          owlSlideshow.owlCarousel({
            nav: true,
            navElement: 'button',
            navText: [
              '<em class="icon icon-arrow-left"></em><span class="sr-only">Previous slide</span>',
              '<em class="icon icon-arrow-right"></em><span class="sr-only">Next slide</span>',
            ],
            items: 1,
            autoHeight: true,
            dots: false,
            //autoplay: true,
            //autoplayTimeout: 20000,
            loop: true,
          });

          /*$('.slideshow-pause').on('click',function(){ console.log('xa'); console.log(owlSlideshow);
            owlSlideshow.trigger('stop.owl.autoplay');
          })*/
        });


      }

      /*
        var parents = document.getElementsByClassName('slideshow');
        var currentSlide = [];

        if ( parents.length > 0 )
        {
            for (var j = 0; j < parents.length; j++) {
                var dots = parents[j].querySelectorAll('.slideshow-dot');

                currentSlide[j] = 0;

                var slides = parents[j].querySelectorAll('.slideshow-item');

                if ( j === 0 && $(window).width() > 768 ){
                    var slideInterval =  setInterval(nextSlide,10000);
                }

                for ( var x = 0; x < dots.length; x++ ) {
                    dots[x].tempJ = j;
                    dots[x].addEventListener('click', function(e) {
                        //pauseSlideshow();
                        goDotToSlide(this.dataset.position, this, e.target.tempJ);
                    });
                }


            }
        }

        var prev = document.getElementsByClassName('prev--slide');
        if ( prev.length > 0)
        {
            for ( var x = 0; x < prev.length; x++ ) {

                prev[x].addEventListener('click', function(){

                    var slides = this.parentNode.parentNode.getElementsByClassName('slideshow-item');
                    var dots = this.parentNode.parentNode.querySelectorAll('.slideshow-dot');


                    for (j = 0; j < slides.length; j++) {

                        if ( slides[j].classList.contains('showing') ) {
                            var prev_index = j - 1;
                            if ( j == 0 ) {
                                prev_index = slides.length - 1;
                            }

                            dots[j].classList.remove('active');
                            slides[j].classList.remove('showing');
                        }

                    }

                    dots[prev_index].classList.add('active');
                    slides[prev_index].classList.add('showing');


                });
            }
        }

        var next = document.getElementsByClassName('next--slide');
        if ( next.length > 0)
        {
            for ( var x = 0; x < next.length; x++ ) {

                next[x].addEventListener('click', function(){

                    var slides = this.parentNode.parentNode.getElementsByClassName('slideshow-item');
                    var dots = this.parentNode.parentNode.querySelectorAll('.slideshow-dot');

                    for (j = 0; j < slides.length; j++) {

                        if ( slides[j].classList.contains('showing') ) {
                            var next_index = j + 1;
                            if ( j == (slides.length - 1) ) {
                                next_index = 0;
                            }

                            dots[j].classList.remove('active');
                            slides[j].classList.remove('showing');
                        }

                    }

                    dots[next_index].classList.add('active');
                    slides[next_index].classList.add('showing');


                });
            }
        }


        function nextSlide() {
            var j = 0;

            var temp_slideshow = document.getElementsByClassName('slideshow')[j];
            var slides = temp_slideshow.querySelectorAll('.slideshow-item');
            var dots = temp_slideshow.querySelectorAll('.slideshow-dot');

            dots[currentSlide[j]].className = 'slideshow-dot';
            slides[currentSlide[j]].className = 'slideshow-item';
            currentSlide[j] = ((currentSlide[j] + 1)+slides.length)%slides.length;
            slides[currentSlide[j]].className = 'slideshow-item showing';
            dots[currentSlide[j]].className = 'slideshow-dot active';

        }

        function goToSlide(n) {
            dots[currentSlide].className = 'slideshow-dot';
            slides[currentSlide].className = 'slideshow-item';
            currentSlide = (n+slides.length)%slides.length;
            slides[currentSlide].className = 'slideshow-item showing';
            dots[currentSlide].className = 'slideshow-dot active';
        }

        function goDotToSlide(n, dot, parent) {

            if ( parent == 0 ) {
                currentSlide[0] = n;
            }

            var slides = dot.parentNode.parentNode.getElementsByClassName('slideshow-item');
            var dots = dot.parentNode.querySelectorAll('.slideshow-dot');

            for (j = 0; j < dot.parentNode.children.length; j++) {
                dots[j].classList.remove('active');
                slides[j].classList.remove('showing');
            }
            dot.classList.add('active');
            slides[n].classList.add('showing');
        }

        function pauseSlideshow() {
            clearInterval(slideInterval);
        }
      */
    },
  };

  Drupal.behaviors.cpsAccordion = {
    attach: function (context, settings) {
      var acc = document.getElementsByClassName("accordion");
      var i;

      for (i = 0; i < acc.length; i++) {
        acc[i].onclick = function () {
          if (this.classList.contains('active')) {
            this.setAttribute('aria-expanded', false);
          }
          else {
            this.setAttribute('aria-expanded', true);
          }
          this.classList.toggle("active");
          this.nextElementSibling.classList.toggle("show");
        };

        acc[i].addEventListener("keyup", function (event) {
          if (event.keyCode === 13) {
            if (this.classList.contains('active')) {
              this.setAttribute('aria-expanded', false);
            }
            else {
              this.setAttribute('aria-expanded', true);
            }
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("show");
          }
        });
      }

      var hash = window.location.hash.substring(1);

      if (hash) {
        var accordionToClick = document.querySelectorAll(
          "[data-anchor='" + hash + "']"
        );

        if (accordionToClick.length > 0) {
          accordionToClick[0].classList.toggle("active");
          accordionToClick[0].nextElementSibling.classList.toggle("show");
        }
      }
    },
  };

  Drupal.behaviors.cpsAreaSelect = {
    attach: function (context, settings) {
      $(".select--toggle").click(function (e) {
        e.preventDefault();
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).attr('aria-expanded', false);
          $(".select--options--container").removeClass("open");
        } else {
          $(this).addClass("open");
          $(this).attr('aria-expanded', true);
          $(".select--options--container").addClass("open");
        }
      });
    },
  };

  Drupal.behaviors.cpsCarousel = {
    attach: function (context, settings) {
      if ($(".owl-carousel")) {
        $(".owl-carousel").each(function (index) {
          //console.log('carousel' + index );
          var len = $(this).find(".views-item").length;
          //console.log(len);

          $(this).owlCarousel({
            loop: len > 2 ? true : false,
            margin: 40,
            slideBy: "page",
            center: len > 2 ? true : false,
            nav: true,
            navElement: 'button',
            navText: [
              '<em class="icon icon-arrow-left"></em><span class="sr-only">Previous slide</span>',
              '<em class="icon icon-arrow-right"></em><span class="sr-only">Next slide</span>',
            ],
            stageOuterClass:
              len > 2 ? "owl-stage-outer" : "owl-stage-outer no-fade",
            responsive: {
              0: {
                items: 1,
              },
              600: {
                items: 3,
              },
              1000: {
                items: 5,
              },
            },
          });
        });
      }

      /*$('.owl-carousel').owlCarousel({
            loop:true,
            margin:40,
            slideBy: 'page',
            center: true,
            nav:true,
            navText: ['<i class="icon icon-arrow-left"></i>','<i class="icon icon-arrow-right"></i>'],
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:3
                },
                1000:{
                    items:5
                }
            },
            onInitialize: function (event) {
                if ($('.owl-carousel').find('.views-item').length <= 1) {
                   this.settings.loop = false;
                }
            }
        });*/
    },
  };

  Drupal.behaviors.cpsAccessibility = {
    attach: function (context, settings) {
      $(".accessibility--control").click(function (e) {
        var accessibilityFeature = $(this).attr("data-accessibility-feature");
        var accessibilityUnit = $(this).attr("data-accessibility-unit");
        if (accessibilityFeature === "fontSize") {
          $("body").css("font-size", accessibilityUnit + "em");
        } else if (accessibilityFeature === "colourContrast") {
          $("body").removeClass("theme__soft theme__blue theme__hivis");
          $("body").addClass("theme__" + accessibilityUnit);
        }
        eraseCookie(accessibilityFeature);
        createCookie(accessibilityFeature, accessibilityUnit, 365);
      });

      var textCookie = readCookie("fontSize");
      if (textCookie) {
        $("body").css("font-size", textCookie + "em");
      }
      var contrastCookie = readCookie("colourContrast");
      if (contrastCookie) {
        $("body").addClass("theme__" + contrastCookie);
      }

      //cookie functions http://www.quirksmode.org/js/cookies.html
      function createCookie(name, value, days) {
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
      }
      function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
      function eraseCookie(name) {
        createCookie(name, "", -1);
      }
      //cookie functions

      //feedback modal
      if ($("#feedback-modal")) {

        var popup_count;
        var popup_hide;

        // After how many page visits the modal will be triggered (set 1 to triggered at first page view)
        const showAfter = 1;

        // After how many page visits the counter will be reset and the modal will be triggered again in the same session.
        // Set this to false to trigger modal only once or set an integer (eg 6)
        const countReset = false;

        // Include homepage in counter (true or false)
        const skipHomePage = false;

        // Initialize local storage with default value.
        popup_count = sessionStorage.getItem("popup-count") ?? 0;
        popup_hide = sessionStorage.getItem("popup-hide") ?? 0;
        sessionStorage.setItem("popup-count", popup_count);
        sessionStorage.setItem("popup-hide", popup_hide);

        if (skipHomePage && $("body").hasClass("frontpage")) {
          popup_count = parseInt(sessionStorage.getItem("popup-count"));
        }
        else {
          popup_count = parseInt(sessionStorage.getItem("popup-count")) + 1;
        }


        if (popup_count >= showAfter && parseInt(sessionStorage.getItem("popup-hide")) === 0) {
          window.setTimeout(function () {
            $("#feedback-modal").addClass("active");
          }, 1000);
          $("#close-modal").on("click", function (e) {

            e.preventDefault();
            $("#feedback-modal").removeClass("active");
            sessionStorage.setItem("popup-hide", '1');

          });
        }

        sessionStorage.setItem("popup-count", popup_count);

        // Reset counter.
        if (countReset && sessionStorage.getItem("popup-count") > countReset) {
          sessionStorage.removeItem("popup-count");
          sessionStorage.setItem("popup-hide", '0');
        }
      }
    },
  };

  Drupal.behaviors.cpsGoogleEvents = {
    attach: function (context, settings) {
      //YouTube Video

      $(document).ready(function () {
        var video_flag = 0;

        var videoId = 0;

        $("iframe").each(function () {
          var src = $(this).attr("src");
          if (
            src.indexOf("https://www.youtube.com") === 0 ||
            src.indexOf("http://www.youtube.com") === 0 ||
            src.indexOf("https://www.youtube-nocookie.com") === 0 ||
            src.indexOf("http://www.youtube-nocookie.com") === 0
          ) {
            $(this).attr("id", "player" + videoId);
            var new_src = src + "?enablejsapi=1";
            var srcCheckParam = src.split("?");
            if (srcCheckParam.length > 1 && srcCheckParam[1] !== "") {
              new_src = src + "&enablejsapi=1";
            }
            $(this).attr("src", new_src);
          }
          video_flag = 1;
          videoId++;
        });

        var playersAll = document.querySelectorAll('iframe[src*="youtube"]');

        var ik_player;
        var playCount = 0;

        window.onYouTubeIframeAPIReady = function () {
          playersAll.forEach(function (e) {
            ik_player = new YT.Player(e.id, {
              events: {
                onStateChange: onPlayerStateChange,
              },
            });
            // ik_player.addEventListener(
            //   "onStateChange",
            //   onPlayerStateChange
            // );
            // // ik_players.push(ik_player);
            // console.log(ik_player);
          });
        };

        function onPlayerStateChange(event) {
          var title = event.target.getVideoData().title;
          // console.log("video-title : " + title);
          switch (event.data) {
            case YT.PlayerState.PLAYING:
              if (playCount == 0) {
                // console.log("first play");
                playCount = 1;

                _paq.push(["trackEvent", "Video", "First Play", title]);
              }

              // console.log("play");
              _paq.push(["trackEvent", "Video", "Play", title]);

              break;
            case YT.PlayerState.PAUSED:
              _paq.push(["trackEvent", "Video", "Pause", title]);

              break;
            case YT.PlayerState.ENDED:
              _paq.push(["trackEvent", "Video", "End", title]);

              break;
          }
        }
      });

      //Downloads events
      // Attach mousedown, keyup, touchstart events to document only and catch
      // clicks on all elements.
      // $(document.body).on("mousedown keyup touchstart", function(event) {
      //   // Catch the closest surrounding link of a clicked element.
      //   $(event.target)
      //     .closest("a,area")
      //     .each(function() {
      //       // Is the clicked URL internal?
      //       if (isInternal(this.href)) {
      //         // Skip 'click' tracking, if custom tracking events are bound.
      //         if ($(this).is(".colorbox")) {
      //           // Do nothing here. The custom event will handle all tracking.
      //           // console.info('Click on .colorbox item has been detected.');
      //         }
      //         // Is download tracking activated and the file extension configured
      //         // for download tracking?
      //         else if (isDownload(this.href)) {
      //           // Download link clicked.
      //           ga("send", {
      //             hitType: "event",
      //             eventCategory: "Downloads",
      //             eventAction: getDownloadExtension(this.href).toUpperCase(),
      //             eventLabel: getPageUrl(this.href),
      //             transport: "beacon",
      //           });
      //         }
      //       } else {
      //         if ($(this).is("a[href^='mailto:'],area[href^='mailto:']")) {
      //           // Mailto link clicked.
      //           ga("send", {
      //             hitType: "event",
      //             eventCategory: "Mails",
      //             eventAction: "Click",
      //             eventLabel: this.href.substring(7),
      //             transport: "beacon",
      //           });
      //         } else if (this.href.match(/^\w+:\/\//i)) {
      //           var trackCrossDomains = [];
      //           if (!isCrossDomain(this.hostname, trackCrossDomains)) {
      //             // External link clicked / No top-level cross domain clicked.
      //             ga("send", {
      //               hitType: "event",
      //               eventCategory: "Outbound links",
      //               eventAction: "Click",
      //               eventLabel: this.href,
      //               transport: "beacon",
      //             });
      //           }
      //         }
      //       }
      //     });
      // });

      /**
       * Check whether the hostname is part of the cross domains or not.
       *
       * @param {string} hostname
       *   The hostname of the clicked URL.
       * @param {array} crossDomains
       *   All cross domain hostnames as JS array.
       *
       * @return {boolean} isCrossDomain
       */
      function isCrossDomain(hostname, crossDomains) {
        return $.inArray(hostname, crossDomains) > -1 ? true : false;
      }

      /**
       * Check whether this is a download URL or not.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {boolean} isDownload
       */
      function isDownload(url) {
        var trackDownloadExtensions =
          "7z|aac|arc|arj|asf|asx|avi|bin|csv|doc(x|m)?|dot(x|m)?|exe|flv|gif|gz|gzip|hqx|jar|jpe?g|js|mp(2|3|4|e?g)|mov(ie)?|msi|msp|pdf|phps|png|ppt(x|m)?|pot(x|m)?|pps(x|m)?|ppam|sld(x|m)?|thmx|qtm?|ra(m|r)?|sea|sit|tar|tgz|torrent|txt|wav|wma|wmv|wpd|xls(x|m|b)?|xlt(x|m)|xlam|xml|z|zip|odt|ods";
        var isDownload = new RegExp(
          "\\.(" + trackDownloadExtensions + ")([?#].*)?$",
          "i"
        );
        return isDownload.test(url);
      }

      /**
       * Check whether this is an absolute internal URL or not.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {boolean} isInternal
       */
      function isInternal(url) {
        var isInternal = new RegExp("^(https?)://" + window.location.host, "i");
        return isInternal.test(url);
      }

      /**
       * Check whether this is a special URL or not.
       *
       * URL types:
       *  - gotwo.module /go/* links.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {boolean} isInternalSpecial
       */
      function isInternalSpecial(url) {
        var isInternalSpecial = new RegExp("(/go/.*)$", "i");
        return isInternalSpecial.test(url);
      }

      /**
       * Extract the relative internal URL from an absolute internal URL.
       *
       * Examples:
       * - http://mydomain.com/node/1 -> /node/1
       * - http://example.com/foo/bar -> http://example.com/foo/bar
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {string} getPageUrl
       *   Internal website URL.
       */
      function getPageUrl(url) {
        var extractInternalUrl = new RegExp(
          "^(https?)://" + window.location.host,
          "i"
        );
        return url.replace(extractInternalUrl, "");
      }

      /**
       * Extract the download file extension from the URL.
       *
       * @param {string} url
       *   The web url to check.
       *
       * @return {string} getDownloadExtension
       *   The file extension of the passed url. e.g. 'zip', 'txt'
       */
      function getDownloadExtension(url) {
        var trackDownloadExtensions =
          "7z|aac|arc|arj|asf|asx|avi|bin|csv|doc(x|m)?|dot(x|m)?|exe|flv|gif|gz|gzip|hqx|jar|jpe?g|js|mp(2|3|4|e?g)|mov(ie)?|msi|msp|pdf|phps|png|ppt(x|m)?|pot(x|m)?|pps(x|m)?|ppam|sld(x|m)?|thmx|qtm?|ra(m|r)?|sea|sit|tar|tgz|torrent|txt|wav|wma|wmv|wpd|xls(x|m|b)?|xlt(x|m)|xlam|xml|z|zip|odt|ods";
        var extractDownloadextension = new RegExp(
          "\\.(" + trackDownloadExtensions + ")([?#].*)?$",
          "i"
        );
        var extension = extractDownloadextension.exec(url);
        return extension === null ? "" : extension[1];
      }
    },
  };

  // Change annual report contents, if language CY.
  Drupal.behaviors.cpsAnnualReportTranslation = {
    attach: function (context, settings) {
      const lang = document.documentElement.lang;
      if (lang == 'cy') {
        setTimeout(function () { document.getElementById('annualReportToC').firstChild.innerHTML = 'Cynnwys'; }, 500);
      }
    },
  };
})(jQuery);
